"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _lodash = require("lodash");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _reactAddonsUpdate = _interopRequireDefault(require("react-addons-update"));
var _reactRouterDom = require("react-router-dom");
var _CheckboxValidatorElement = _interopRequireDefault(require("./CheckboxValidatorElement"));
var _CustomDescription = _interopRequireDefault(require("./CustomDescription"));
var _CustomPhoneNumberInput = _interopRequireDefault(require("./CustomPhoneNumberInput"));
var _RadioGroupValidatorElement = _interopRequireDefault(require("./RadioGroupValidatorElement"));
var _CustomHint = _interopRequireDefault(require("./CustomHint"));
var _CustomSelect = _interopRequireDefault(require("./CustomSelect"));
var _CustomTextFieldDefaultValue = _interopRequireDefault(require("./CustomTextFieldDefaultValue"));
var _CustomTextField = _interopRequireDefault(require("./CustomTextField"));
var _CustomTextArea = _interopRequireDefault(require("./CustomTextArea"));
var _CustomTechnologyInstallation = _interopRequireDefault(require("./CustomTechnologyInstallation"));
var _CustomDigitalRadarTechnologyInstallation = _interopRequireDefault(require("./CustomDigitalRadarTechnologyInstallation"));
var _CustomTechnologyPlans = _interopRequireDefault(require("./CustomTechnologyPlans"));
var _CustomVendorProductSelect = _interopRequireDefault(require("./CustomVendorProductSelect"));
var _CustomDiamQuestion = _interopRequireDefault(require("./CustomDiamQuestion"));
var _CustomRespondentInformation = _interopRequireDefault(require("./CustomRespondentInformation"));
var _CustomDiamFreeTextQuestion = _interopRequireDefault(require("./CustomDiamFreeTextQuestion"));
var _CustomDiamServiceCheckbox = _interopRequireDefault(require("./CustomDiamServiceCheckbox"));
var _CustomCertifiedOrg = _interopRequireDefault(require("./CustomCertifiedOrg"));
var _CustomAddress = _interopRequireDefault(require("./CustomAddress"));
var _CustomCheckboxText = _interopRequireDefault(require("./CustomCheckboxText"));
var _CustomNumber = _interopRequireDefault(require("./CustomNumber"));
var _CustomMatrix = _interopRequireDefault(require("./CustomMatrix"));
var _CustomFileUpload = _interopRequireDefault(require("./CustomFileUpload"));
var _surveyUtils = require("../../utilities/surveyUtils");
var _getResource = require("../../utilities/getResource");
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _EventBus = require("@survey/common/dist/utilities/EventBus");
var _moment = _interopRequireDefault(require("moment"));
require("moment/locale/de");
require("moment/locale/fr");
require("moment/locale/it");
require("moment/locale/pl");
require("moment/locale/es");
require("moment/locale/pt");
require("moment/locale/tr");
require("moment/locale/en-gb");
require("moment/locale/ja");
require("moment/locale/ko");
require("moment/locale/id");
require("moment/locale/zh-cn");
var _htmlReactParser = _interopRequireDefault(require("html-react-parser"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // German
// French
// Italian
// Polish
// Spanish
// Portuguese
// Turkish
// British English
// Japanese
// Korean
// Indonesian
// Chinese
var styles = function styles(theme) {
  return {
    form: {
      marginTop: "".concat(theme.spacing(2), " !important"),
      marginBottom: "".concat(theme.spacing(2), " !important"),
      marginLeft: "".concat(theme.spacing(2), " !important"),
      marginRight: "".concat(theme.spacing(2), " !important")
    },
    formControl: {
      display: 'block !important',
      marginBottom: "".concat(theme.spacing(6), " !important"),
      marginTop: "".concat(theme.spacing(4), " !important")
    },
    formControlNoBottom: {
      display: 'block !important',
      marginBottom: "".concat(theme.spacing(1), " !important"),
      marginTop: "".concat(theme.spacing(4), " !important")
    },
    formControlDesc: {
      display: 'block !important',
      marginBottom: "".concat(theme.spacing(4), " !important"),
      marginTop: "".concat(theme.spacing(4), " !important")
    },
    padTop: {
      marginTop: 12
    },
    titleOne: {
      fontSize: '1rem',
      display: 'flex'
    },
    textField: {
      width: '100%',
      fontSize: 12
    },
    select: {
      marginTop: "".concat(theme.spacing(2), " !important"),
      width: '100%'
    },
    radioGroup: {
      marginBottom: "".concat(theme.spacing(2), " !important")
      /*width: '100%'*/
    },
    button: {
      margin: "".concat(theme.spacing(1), " !important")
    },
    smallSelect: {
      display: 'block'
    },
    hint: {
      marginLeft: '10px !important',
      color: '#fff !important',
      backgroundColor: '#1a25ab !important',
      borderRadius: '21px !important',
      cursor: 'pointer !important',
      display: 'block !important',
      width: '11px !important',
      textAlign: 'center !important',
      padding: '2px !important',
      fontSize: '10px !important',
      position: 'relative !important'
    },
    datePicker: {
      borderTop: 'none',
      borderLeft: 'none',
      borderRight: 'none',
      marginBottom: '15px',
      fontFamily: '"Verlag Bold", Arial, Helvetica, sans-serif !important'
    }
  };
};
var CustomForm = /*#__PURE__*/function (_Component) {
  function CustomForm(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomForm);
    _this = _callSuper(this, CustomForm, [props]);
    _this.state = {
      data: {},
      changes: {},
      commentChanges: {},
      prevData: {},
      prevEntity: {},
      questions: [],
      techQuestionsForm: null,
      tabId: props.tabId //Adding to state so we can compare when the tabId changes
    };

    // Create a reference for the form.
    _this.form = /*#__PURE__*/_react["default"].createRef();
    ['getValue', 'setLocale', 'createFormElements', 'updateSelectedFields', 'updateFields', 'showError', 'getQuestionData', 'saveSurvey'].map(function (k) {
      return _this[k] = _this[k].bind(_this);
    });
    return _this;
  }
  (0, _inherits2["default"])(CustomForm, _Component);
  return (0, _createClass2["default"])(CustomForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      _EventBus.EventBus.on('SurveySave', function () {
        _this2.saveSurvey(false);
      });
    }
  }, {
    key: "setLocale",
    value: function setLocale(language) {
      if (!language) {
        _moment["default"].locale('en');
      } else {
        switch (language) {
          case 'German':
            _moment["default"].locale('de');
            break;
          case 'French':
            _moment["default"].locale('fr');
            break;
          case 'Italian':
            _moment["default"].locale('it');
            break;
          case 'Polish':
            _moment["default"].locale('pl');
            break;
          case 'Spanish':
            _moment["default"].locale('es');
            break;
          case 'Portuguese':
            _moment["default"].locale('pt');
            break;
          case 'Turkish':
            _moment["default"].locale('tr');
            break;
          case 'British English':
            _moment["default"].locale('en-gb');
            break;
          case 'Japanese':
            _moment["default"].locale('ja');
            break;
          case 'Korean':
            _moment["default"].locale('ko');
            break;
          case 'Indonesian':
            _moment["default"].locale('id');
            break;
          case 'Chinese':
            _moment["default"].locale('zh-cn');
            break;
          default:
            _moment["default"].locale('en');
        }
      }
    }
  }, {
    key: "getQuestionData",
    value: function getQuestionData(questionData, questionID) {
      var _this3 = this;
      var answer = [];
      Object.keys(questionData).forEach(function (k) {
        if (k == questionID) {
          answer = questionData[questionID];
        }
        if (questionData[k].questions.length > 0) {
          answer = _this3.getQuestionData(questionData[k].questions, questionID);
        }
      });
      return answer;
    }
  }, {
    key: "showError",
    value: function showError(errorMessage) {
      this.setState({
        promptError: errorMessage !== '',
        errorMessage: errorMessage
      });
      this.props.showAlert(errorMessage);
    }
  }, {
    key: "saveSurvey",
    value: function () {
      var _saveSurvey = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var _this4 = this;
        var _this$props, entity, techQuestionsForm, surveyTemplate, onSaveChanges, data, changes;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, entity = _this$props.entity, techQuestionsForm = _this$props.techQuestionsForm, surveyTemplate = _this$props.surveyTemplate, onSaveChanges = _this$props.onSaveChanges;
              console.log('changes', this.state.changes);
              if (!(surveyTemplate !== 'One Page')) {
                _context.next = 1;
                break;
              }
              data = _objectSpread({}, entity.data);
              if (techQuestionsForm) {
                data = _objectSpread(_objectSpread({}, data), {}, {
                  technologyQuestions: _objectSpread({}, this.state.data)
                });
              } else {
                data = _objectSpread(_objectSpread({}, data), {}, {
                  questions: _objectSpread({}, this.state.data)
                });
              }
              if (!(!(0, _lodash.isEqual)(data, entity.data) && (!(0, _lodash.isEmpty)(this.state.changes) || !(0, _lodash.isEmpty)(this.state.commentChanges)))) {
                _context.next = 1;
                break;
              }
              changes = {
                changes: this.state.changes,
                commentChanges: this.state.commentChanges,
                updatedEntityData: data
              };
              console.log('Saving survey from CustomForm.js...', changes);
              _context.next = 1;
              return onSaveChanges(changes).then(function (json) {
                _this4.setState({
                  changes: {},
                  commentChanges: {}
                });
              });
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function saveSurvey() {
        return _saveSurvey.apply(this, arguments);
      }
      return saveSurvey;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.props.isApiError) {
        this.saveSurvey();
      }
      _EventBus.EventBus.remove('SurveySave');
    }
  }, {
    key: "makeCommentProp",
    value: function makeCommentProp(prop, value) {
      var lastElem = 0;
      var obj = {
        comment: value
      };
      if (this.props.techQuestionsForm) {
        lastElem = 1;
      }

      // Dig down into the data object to get the question data.
      for (var i = prop.length - 1; i >= lastElem; i--) {
        // If this is the last element, don't apply the questions suffix.
        if (i === lastElem) {
          // obj[prop[i]] = ;
          obj = (0, _defineProperty2["default"])({}, prop[i], obj);
        } else {
          // obj[prop[i]] = { answer: value };
          obj = {
            questions: (0, _defineProperty2["default"])({}, prop[i], obj)
          };
        }
      }
      if (this.props.techQuestionsForm) {
        var _techID = prop[0];
        obj = (0, _defineProperty2["default"])({}, _techID, obj);
      }
      var qIDs = (0, _lodash.cloneDeep)(prop);
      var techID = null;
      if (this.props.techQuestionsForm) {
        techID = qIDs.shift();
      }
      var change = {};
      var val = {};
      val['value'] = value;
      val['techID'] = techID;
      change["".concat(qIDs)] = val;
      this.setState({
        commentChanges: (0, _reactAddonsUpdate["default"])(this.state.commentChanges, {
          $merge: change
        })
      });
      return obj;
    }
    // https://stackoverflow.com/questions/30899454/dynamic-key-in-immutability-update-helper-for-array
  }, {
    key: "makeProp",
    value: function makeProp(prop, value) {
      var lastElem = 0;
      var obj = {
        answer: value
      };
      if (this.props.techQuestionsForm) {
        lastElem = 1;
      }

      // Dig down into the data object to get the question data.
      for (var i = prop.length - 1; i >= lastElem; i--) {
        // If this is the last element, don't apply the questions suffix.
        if (i === lastElem) {
          // obj[prop[i]] = ;
          obj = (0, _defineProperty2["default"])({}, prop[i], obj);
        } else {
          // obj[prop[i]] = { answer: value };
          obj = {
            questions: (0, _defineProperty2["default"])({}, prop[i], obj)
          };
        }
      }
      if (this.props.techQuestionsForm) {
        var _techID2 = prop[0];
        obj = (0, _defineProperty2["default"])({}, _techID2, obj);
      }
      var qIDs = (0, _lodash.cloneDeep)(prop);
      var techID = null;
      if (this.props.techQuestionsForm) {
        techID = qIDs.shift();
      }
      var change = {};
      var val = {};
      val['value'] = value;
      val['techID'] = techID;
      change["".concat(qIDs)] = val;
      this.setState({
        changes: (0, _reactAddonsUpdate["default"])(this.state.changes, {
          $merge: change
        })
      });
      return obj;
    }
  }, {
    key: "getQuestionCommentValue",
    value: function getQuestionCommentValue(data, questionIDs) {
      if ((0, _lodash.isEmpty)(data) || questionIDs.length === 0) {
        return '';
      }
      var qIDs = (0, _lodash.cloneDeep)(questionIDs);
      var questionData = data[qIDs[0]];
      /* For tech questions, the first questionIDs element is the technologyID so update the array and the questionData object to reflect that. */
      if (this.props.techQuestionsForm) {
        var techID = qIDs.shift();
        questionData = data[techID];
      }
      return questionData.comment;
    }
  }, {
    key: "getValue",
    value: function getValue(isCurrentData, questionIDs, dropdownAnswers) {
      var _this5 = this;
      var qIDs = (0, _lodash.cloneDeep)(questionIDs);
      var data = isCurrentData ? this.state.data : this.state.prevData;
      if ((0, _lodash.isEmpty)(data)) {
        return '';
      }
      var questionData = data;
      /* For tech questions, the first questionIDs element is the technologyID so update the array and the questionData object to reflect that. */
      if (this.props.techQuestionsForm) {
        var techID = qIDs.shift();
        questionData = data[techID];
      }
      var questionID = qIDs.slice(-1)[0];
      var question = (0, _lodash.find)(this.props.questions, {
        questionID: questionID
      });
      /* If the question can't be found, return an empty string */
      if (!question) {
        return '';
      }

      // Dig down into the data object to get the question data.
      for (var i = 0; i < qIDs.length; i++) {
        /* If questionData is null, props are probably in an unstable state so
                return an empty string and wait for them to stablize. */
        if (!questionData) {
          return '';
        }

        // If this is the last element, don't apply the questions suffix.
        if (qIDs.length === 1) {
          questionData = questionData[qIDs[i]];
        } else if (i === qIDs.length - 1) {
          questionData = questionData[qIDs[i]];
        } else {
          //We can't guarentee the questionData will exist in prevData so skipping if it doesn't
          if (questionData[qIDs[i]]) {
            questionData = questionData[qIDs[i]].questions;
          }
        }
      }
      if (question.controlType === 'TextBox' || question.controlType === 'TextArea' || question.controlType.match(/RadioButtonList/) || question.controlType === 'CustomCertifiedOrg' || question.controlType === 'FileUpload') {
        if (!questionData || questionData.answer === null || (0, _lodash.isEmpty)(questionData.answer)) return '';
        return questionData.answer[0];
      } else if (question.controlType === 'Matrix') {
        if (!questionData || questionData.answer === null || (0, _lodash.isEmpty)(questionData.answer)) return '';
        return JSON.parse(questionData.answer[0]);
      } else if (question.controlType.match(/CheckBoxList/) || question.controlType === 'TechnologyInstallation' || question.controlType === 'VendorProductSelect' || question.controlType === 'MultiVendorProductSelect' || question.controlType === 'TechnologyPlans' || question.controlType === 'DiamQuestion' || question.controlType === 'CustomDiamServiceCheckbox' || question.controlType === 'CustomCheckboxText' || question.controlType === 'DiamTechnologyInstallation' || question.controlType === 'DiamTechnologyInstallation_NoIntegrationLevel' || question.controlType === 'DigitalRadarTechnologyInstallation' || question.controlType === 'DigitalRadarTechnologyInstallation_NoIntegrationLevel' || question.controlType === 'DiamRespondentInfo' || question.controlType === 'DiamFreeTextQuestion' || question.controlType === 'Address') {
        if (!questionData || questionData.answer === null) return [];
        return questionData.answer;
      } else if (question.controlType === 'CustomLabel' || question.controlType === 'Description') {
        if (!questionData || questionData.answer === null || typeof questionData.answer != 'string') return '';
        return questionData.answer;
      } else if (question.controlType === 'Date') {
        /* If the answer has a date string, return that. Otherwise return null so no date will display as selected. */
        if (!questionData.answer.length) {
          var today = new Date().toISOString().slice(0, 10);
          return null;
        } else if (questionData.answer !== '') {
          return questionData.answer[0];
        } else {
          return null;
        }
      } else if (question.controlType.match(/DropDownList/)) {
        // answer is either null or array
        if (!questionData || questionData.answer === null) return [];
        var answerData = [];
        var answer = (0, _lodash.find)(this.props.answers, function (answer) {
          return answer.answerID == question.answerID;
        });
        if (!answer) return;

        // XXX: Remove once all data has been refreshed.
        if (questionData.answer === '') {
          return answerData;
        }
        questionData.answer.forEach(function (a) {
          if (answer.type === 'API') {
            if (dropdownAnswers && a !== null) answerData.push(dropdownAnswers.find(function (dropAnswer) {
              return dropAnswer.value.toString() === a.toString();
            })); //DW bugfix for HAD-1498
          } else {
            var answers = (0, _lodash.cloneDeep)(answer.answers);
            if (_this5.props.language) {
              answers.forEach(function (a) {
                if (a.translations && a.translations[_this5.props.language]) {
                  a.label = a.translations[_this5.props.language];
                }
              });
            }
            answerData.push((0, _lodash.find)(answers, function (answer) {
              return answer.value == a;
            }));
          }
        });
        return question.controlType === 'SingleDropDownList' && answerData.length === 1 ? answerData[0] : answerData;
      } else if (question.controlType === 'State') {
        var options = [];
        if (!(0, _lodash.isEmpty)(this.props.regions)) {
          options = this.props.regions.map(function (i) {
            return {
              value: i.geographicalRegionID.toString(),
              label: i.geographicalRegion
            };
          });
        }
        // answer is either null or array
        if (!questionData || questionData.answer === null) return [];
        var _answerData = [];
        if (questionData.answer === '') {
          return _answerData;
        }
        questionData.answer.forEach(function (a) {
          _answerData.push((0, _lodash.find)(options, {
            value: a
          }));
        });
        return _answerData;
      } else {
        var _answer = (0, _lodash.find)(this.props.answers, {
          answerID: question.answerID
        });
        var _answerData2 = '';
        if (_answer && questionData) _answerData2 = questionData.answer;
        if (!isNaN(_answerData2) && _answerData2 !== '' && _answer && Number(_answerData2) < _answer.answers.length) {
          return _answer.answers[Number(_answerData2)].value;
        }
      }
    }
  }, {
    key: "updateParentData",
    value: function updateParentData(data) {
      var _this$props2 = this.props,
        surveyTemplate = _this$props2.surveyTemplate,
        onSubmit = _this$props2.onSubmit,
        entity = _this$props2.entity,
        techQuestionsForm = _this$props2.techQuestionsForm;
      if (surveyTemplate === 'One Page') {
        var entityData = _objectSpread({}, entity.data);
        if (techQuestionsForm) {
          entityData = _objectSpread(_objectSpread({}, entityData), {}, {
            technologyQuestions: data === undefined ? _objectSpread({}, this.state.data) : _objectSpread({}, data)
          });
        } else {
          entityData = _objectSpread(_objectSpread({}, entityData), {}, {
            questions: data === undefined ? _objectSpread({}, this.state.data) : _objectSpread({}, data)
          });
        }
        onSubmit(entityData);
      }
    }
  }, {
    key: "updateSelectedFields",
    value: function updateSelectedFields(field, preceedingQuestions) {
      var _this6 = this;
      return function (event, value) {
        var question = (0, _lodash.find)(_this6.props.questions, {
          questionID: preceedingQuestions[preceedingQuestions.length - 1]
        });
        if (question) {
          if (question.controlType === 'SingleDropDownList' || question.controlType === 'State') {
            _this6.setState({
              data: (0, _reactAddonsUpdate["default"])(_this6.state.data, _this6.makeProp(preceedingQuestions, {
                $set: value.value === '' ? [] : [value.value]
              }))
            }, function () {
              _this6.updateParentData();
              console.log('updateSelectedFields complete');
            });
          } else {
            if (_this6.props.surveyTemplate === 'One Page') {
              _this6.updateParentData((0, _reactAddonsUpdate["default"])(_this6.state.data, _this6.makeProp(preceedingQuestions, {
                $set: [].concat(value.map(function (v) {
                  return v.value;
                }))
              })));
            } else {
              _this6.setState({
                data: (0, _reactAddonsUpdate["default"])(_this6.state.data, _this6.makeProp(preceedingQuestions, {
                  $set: [].concat(value.map(function (v) {
                    return v.value;
                  }))
                }))
              }, function () {
                return console.log('updateSelectedFields complete');
              });
            }
          }
        }
      };
    }
  }, {
    key: "logIt",
    value: function logIt(a, b, c) {
      console.log('CHANGING', a, b, c);
    }
  }, {
    key: "updatePhoneNumber",
    value: function updatePhoneNumber(preceedingQuestions) {
      var _this7 = this;
      return function (value) {
        _this7.setState({
          data: (0, _reactAddonsUpdate["default"])(_this7.state.data, _this7.makeProp(preceedingQuestions, {
            $set: value !== '' ? [value] : []
          }))
        }, function () {
          _this7.updateParentData();
          console.log('updatePhoneNumber complete');
        });
      };
    }
  }, {
    key: "updateQuestionComment",
    value: function updateQuestionComment(questionIDs) {
      var _this8 = this;
      if ((0, _lodash.isEmpty)(questionIDs)) {
        return '';
      }
      return function (event) {
        _this8.setState({
          data: (0, _reactAddonsUpdate["default"])(_this8.state.data, _this8.makeCommentProp(questionIDs, {
            $set: event.target.value
          }))
        }, function () {
          _this8.updateParentData();
          console.log('updateFields complete');
        });
      };
    }
  }, {
    key: "updateFields",
    value: function updateFields(preceedingQuestions) {
      var _this9 = this;
      return function (event) {
        _this9.setState({
          data: (0, _reactAddonsUpdate["default"])(_this9.state.data, _this9.makeProp(preceedingQuestions, {
            $set: event.target.value !== '' ? [event.target.value] : []
          }))
          //changes: update(this.state.changes, { $merge: this.makeProp(preceedingQuestions, event.target.value !== '' ? [event.target.value] : []) }),
        }, function () {
          _this9.updateParentData();
          console.log('updateFields complete');
        });
      };
    }

    // The parents input argument is an array of questionIds to describe the state depth of the current question. The first level will be an empty array with each subsequent level being added.
  }, {
    key: "createFormElements",
    value: function createFormElements(parentQuestionNumbers, questionNumber, question) {
      var _this0 = this;
      var parents = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      if (!question.active) return;
      var elementKey = question.questionID;
      var _this$props3 = this.props,
        classes = _this$props3.classes,
        answers = _this$props3.answers,
        resources = _this$props3.resources,
        language = _this$props3.language;
      var answer = (0, _lodash.find)(answers, {
        answerID: question.answerID
      });
      if (question.answerKeys && question.answerKeys.length > 0) {
        question.answerKeys.some(function (answerKey) {
          var data = _this0.props.techQuestionsForm ? _this0.state.data[_this0.props.tabId] : _this0.state.data;
          var q = (0, _lodash.find)(_this0.props.allQuestions, {
            questionID: answerKey.questionID
          });
          var answersList = CustomForm.getAnswers(data, answerKey.questionID);
          if (q.controlType === 'TechnologyInstallation' || q.controlType === 'DiamTechnologyInstallation' || q.controlType === 'DiamTechnologyInstallation_NoIntegrationLevel' || q.controlType === 'DigitalRadarTechnologyInstallation' || q.controlType === 'DigitalRadarTechnologyInstallation_NoIntegrationLevel') {
            answersList = answersList.map(function (a) {
              var arr = JSON.parse(a);
              return arr[0];
            });
            answersList = (0, _lodash.uniq)(answersList);
          }
          if (q.controlType === 'CustomDiamServiceCheckbox') {
            answersList = answersList.map(function (a) {
              var svc = JSON.parse(a);
              return svc.serviceID;
            });
            answersList = (0, _lodash.uniq)(answersList);
          }
          if (q.controlType === 'CustomCheckboxText') {
            answersList = answersList.map(function (a) {
              var svc = JSON.parse(a);
              return svc.valueID;
            });
            answersList = (0, _lodash.uniq)(answersList);
          }
          if (q.controlType === 'CustomCertifiedOrg') {
            answersList = answersList.map(function (a) {
              var arr = JSON.parse(a);
              return arr[0];
            });
            answersList = (0, _lodash.uniq)(answersList);
          }
          var overrideAnswerKey = answerKey.answers.every(function (a) {
            return answersList.indexOf(a) > -1;
          });
          if (overrideAnswerKey) {
            answer = (0, _lodash.find)(answers, {
              answerID: answerKey.answerKey
            });
            console.log('answer list', answers, answer, answerKey.answerKey);
            elementKey = "".concat(question.questionID, "-answeroverride-").concat(answer ? answer.answerID : 0);
          }
          return overrideAnswerKey;
        });
      }
      var dropdownAnswers = [];
      if (answer) {
        if (answer.type === 'API') {
          dropdownAnswers = this.props[answer.apiName];
        } else {
          dropdownAnswers = (0, _lodash.cloneDeep)(answer.answers);
          if (this.props.language) {
            dropdownAnswers.forEach(function (a) {
              if (a.translations && a.translations[_this0.props.language]) {
                a.label = a.translations[_this0.props.language];
              }
            });
          }
        }
      }

      //testing additionalDescription:
      //question.additionalDescription = 'This is the additional description';
      var parentQuestionNumberLabel = parentQuestionNumbers !== null ? "".concat(parentQuestionNumbers.join('.'), ".") : '';
      var questionNumberLabel = "".concat(parentQuestionNumberLabel + questionNumber, ".");
      if (question.controlType.match(/DropDownList/)) {
        var isMulti = false;
        if (question.controlType === 'MultiDropDownList') {
          isMulti = true;
        }
        var prevData = this.getValue(false, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers));
        var curData = this.getValue(true, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers));
        var showPrevData = !(0, _lodash.isEmpty)(curData) && !(0, _lodash.isEmpty)(prevData) && !(0, _lodash.isEqual)(prevData, curData);
        var blankOption = [{
          label: '',
          value: ''
        }];
        //var labelValue = question.questionDescription;
        var prevLabelValue = (0, _getResource.getResource)(resources, language, 'Label', 'Prior Response');
        if (question.additionalDescription !== null && question.additionalDescription !== '' && !question.additionalDescription.includes('<div>')) {
          //labelValue = labelValue + '  (' + question.additionalDescription + ')';
          prevLabelValue = prevLabelValue + '  (' + question.additionalDescription + ')';
        }
        //const validator = question.mappingGroupAttribute == '97' ? ['contractSignedDateValidation'] : [];
        //const message = question.mappingGroupAttribute == '97' ? ['Value should be greater than or equal to current year'] : [];
        return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          container: true,
          spacing: 8,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: 12,
          sm: showPrevData ? 6 : 12
        }, /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: !showPrevData ? classes.formControlNoBottom : classes.smallSelect,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          key: elementKey,
          id: elementKey,
          questionDescription: "".concat(questionNumberLabel, " ").concat(question.questionDescription),
          value: this.getValue(true, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers)),
          onChange: this.updateSelectedFields,
          parents: parents,
          question: question.questionID,
          options: blankOption.concat([].concat(dropdownAnswers)),
          disabled: false,
          placeholder: question.questionDescription,
          label: "",
          name: "".concat(question.questionID),
          className: classes.select,
          isMulti: isMulti,
          required: question.isRequired
        })))), showPrevData && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: 32,
            paddingTop: 15
          }
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          value: this.getValue(false, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers)),
          onChange: this.updateSelectedFields,
          parents: parents,
          question: question.questionID,
          options: blankOption.concat([].concat(dropdownAnswers)),
          disabled: true,
          placeholder: question.questionDescription,
          label: prevLabelValue,
          name: "".concat(question.questionID, "prev"),
          className: classes.select,
          isMulti: isMulti
        }))));
      } else if (question.controlType === 'State') {
        console.log('props.countryQuestion', this.props.countryQuestion);
        var countryID = 0;
        var options = [];
        if (this.props.countryQuestion) {
          if (this.state.data[this.props.countryQuestion.questionID].answer.length > 0) countryID = this.state.data[this.props.countryQuestion.questionID].answer[0];
        }
        var _isMulti = false;
        var _prevData = this.getValue(false, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers));
        var _curData = this.getValue(true, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers));
        var _showPrevData = !(0, _lodash.isEmpty)(_curData) && !(0, _lodash.isEmpty)(_prevData) && !(0, _lodash.isEqual)(_prevData, _curData);
        var _blankOption = [{
          label: '',
          value: ''
        }];
        //let labelValue = question.questionDescription;
        var _prevLabelValue = (0, _getResource.getResource)(resources, language, 'Label', 'Prior Response');
        if (question.additionalDescription !== null && question.additionalDescription !== '' && !question.additionalDescription.includes('<div>')) {
          //labelValue = labelValue + '  (' + question.additionalDescription + ')';
          _prevLabelValue = _prevLabelValue + '  (' + question.additionalDescription + ')';
        }
        if (!(0, _lodash.isEmpty)(this.props.regions)) {
          var regions = this.props.regions;
          if (countryID > 0) {
            regions = regions.reduce(function (all, r) {
              if (r.countryID == countryID) all.push(r);
              return all;
            }, []);
          }
          options = regions.map(function (i) {
            return {
              value: i.geographicalRegionID.toString(),
              label: i.geographicalRegion
            };
          });
        }
        options = (0, _lodash.sortBy)(options, ['label']);
        return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          container: true,
          spacing: 8,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: 12,
          sm: _showPrevData ? 6 : 12
        }, /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: !_showPrevData ? classes.formControlNoBottom : classes.smallSelect,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          key: elementKey,
          value: this.getValue(true, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers)),
          onChange: this.updateSelectedFields,
          parents: parents,
          question: question.questionID,
          options: _blankOption.concat([].concat(options)),
          disabled: false,
          placeholder: question.questionDescription,
          label: "",
          name: "".concat(question.questionID),
          className: classes.select,
          isMulti: _isMulti
        })))), _showPrevData && /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: 12,
          sm: 6
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            marginBottom: 32,
            paddingTop: 15
          }
        }, /*#__PURE__*/_react["default"].createElement(_CustomSelect["default"], {
          value: this.getValue(false, [].concat(parents, [question.questionID]), [].concat(dropdownAnswers)),
          onChange: this.updateSelectedFields,
          parents: parents,
          question: question.questionID,
          options: _blankOption.concat([].concat(dropdownAnswers)),
          disabled: true,
          placeholder: question.questionDescription,
          label: _prevLabelValue,
          name: "".concat(question.questionID, "prev"),
          className: classes.select,
          isMulti: _isMulti
        }))));
      } else if (question.controlType.match(/(Horizontal|Vertical)?RadioButtonList$/)) {
        var direction = 'vertical';
        if (question.controlType.match(/^Horizontal/)) {
          direction = 'horizontal';
        }
        var validators = [];
        var errorMessages = [];
        if (question.isRequired) {
          validators.push('customRequired');
          errorMessages.push('This field is required');
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), "\xA0\xA0 ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_RadioGroupValidatorElement["default"], {
          key: elementKey,
          name: question.questionID,
          className: classes.radioGroup,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          direction: direction,
          onChange: this.updateFields([].concat(parents, [question.questionID])),
          previousValue: this.getValue(false, [].concat(parents, [question.questionID])),
          answers: [].concat(dropdownAnswers),
          resources: resources,
          language: language,
          required: question.isRequired,
          validators: validators,
          errorMessages: errorMessages,
          questionDescription: "".concat(questionNumberLabel, " ").concat(question.questionDescription)
        })));
      } else if (question.controlType === 'Matrix') {
        var previousValue = this.getValue(false, [].concat(parents, [question.questionID]));
        var _validators = [];
        var _errorMessages = [];
        if (question.isRequired) {
          _validators.push('customRequired');
          _errorMessages.push('This field is required');
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), "\xA0\xA0 ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomMatrix["default"], {
          key: elementKey,
          className: classes.radioGroup,
          resources: resources,
          language: language,
          validators: _validators,
          previousValue: previousValue,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            var valueObj = value.map(function (_ref) {
              var value = _ref.value;
              return value;
            });
            var valueArr = [JSON.stringify(valueObj)];
            if (!value.target) {
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                  $set: valueArr
                }))
              }, function () {
                _this0.updateParentData();
                console.log('CustomMatrix onChange complete');
              });
            }
          },
          answers: [].concat(dropdownAnswers),
          questions: question.childQuestions
        })));
      } else if (question.controlType === 'FileUpload') {
        var _errorMessages2 = [];
        var _validators2 = [];
        if (question.isRequired) {
          _validators2.push('customRequired');
          _errorMessages2.push('This field is required');
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), "\xA0\xA0 ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomFileUpload["default"], {
          key: question.questionID,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          language: this.props.language,
          resources: this.props.resources,
          surveyID: this.props.surveyID,
          entityID: this.props.entity.entityID,
          dataMappingID: question.mappingGroupAttribute,
          questionID: question.questionID,
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: [value]
              }))
            }, function () {
              var qIDs = [].concat(parents, [question.questionID]);
              var change = {};
              var val = {};
              val['value'] = {
                $set: [value]
              };
              change["".concat(qIDs)] = val;
              var changes = {
                changes: (0, _reactAddonsUpdate["default"])(_this0.state.changes, {
                  $merge: change
                }),
                commentChanges: _this0.state.commentChanges,
                updatedEntityData: _this0.state.data
              };
              _this0.updateParentData();
              _this0.props.onSaveChanges(changes);
            });
          }
        })));
      } else if (question.controlType.match(/(Horizontal|Vertical)?CheckBoxList/)) {
        var _direction = 'vertical';
        if (question.controlType.match(/^Horizontal/)) {
          _direction = 'horizontal';
        }
        var _previousValue = this.getValue(false, [].concat(parents, [question.questionID]));
        var _validators3 = [];
        var _errorMessages3 = [];
        if (question.isRequired) {
          _validators3.push('customRequired');
          _errorMessages3.push('This field is required');
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CheckboxValidatorElement["default"], {
          key: elementKey,
          name: question.questionID,
          questionDescription: "".concat(questionNumberLabel, " ").concat(question.questionDescription),
          className: classes.radioGroup,
          allowSelectAll: question.allowSelectAll,
          validators: _validators3,
          errorMessages: _errorMessages3,
          direction: _direction,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          selectAll: function selectAll(event) {
            var theAnswer = [];
            var preceedingQuestions = [].concat(parents, [question.questionID]);
            var allAnswerGroups = [];
            var mostCommonGroup;
            dropdownAnswers.forEach(function (answer) {
              if (answer.groups) {
                answer.groups.forEach(function (group) {
                  allAnswerGroups.push(group);
                });
              }
            });
            if (allAnswerGroups.length > 0) {
              var groupCount = new Map();
              for (var i in allAnswerGroups) {
                if (!groupCount.get(allAnswerGroups[i])) {
                  groupCount.set(allAnswerGroups[i], 1);
                } else {
                  groupCount.set(allAnswerGroups[i], groupCount.get(allAnswerGroups[i]) + 1);
                }
              }
              var max = 0;
              groupCount.forEach(function (value, key) {
                if (max < value) {
                  max = value;
                  mostCommonGroup = key;
                }
              });
            }
            dropdownAnswers.map(function (item) {
              if (mostCommonGroup) {
                if (item.groups && item.groups.indexOf(mostCommonGroup) > -1) {
                  theAnswer.push(item.value);
                }
              } else {
                theAnswer.push(item.value);
              }
            });
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp(preceedingQuestions, {
                $set: theAnswer
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomCheckboxGroup onChange complete');
            });
          },
          deselectAll: function deselectAll(event) {
            var preceedingQuestions = [].concat(parents, [question.questionID]);
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp(preceedingQuestions, {
                $set: []
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomCheckboxGroup onChange complete');
            });
          },
          onChange: function onChange(event) {
            var data = _this0.getValue(true, [].concat(parents, [question.questionID]));
            if (!data) {
              data = [];
            }
            var newArr = (0, _lodash.xor)(data, [event.target.value]); //set it to either data or [event.target.value], so if no [event.target.value], use existing data?
            //get the most recently added item on newArr (the value of the checkbox that was clicked)
            var currentCheckedItemValue = newArr.slice(-1).pop();
            console.log('onChange triggered', dropdownAnswers);
            //get the groups value for the current selected item
            var currGroups = [];
            dropdownAnswers.map(function (item) {
              if (item.value == currentCheckedItemValue) {
                currGroups = item.groups;
              }
            });
            if (currGroups && currGroups.length) {
              console.log('current selected item groups value: ', currGroups);
              //custom answer logic follows
              //newArr is all selected answers for the question, if the current selected answer has a "groups" value, loop through newArr and build a new array
              //do not add an answer to newAnswers if they are not in the current active checked answer's "groups"
              var newAnswers = [];
              if (newArr) {
                newArr.map(function (prevItem) {
                  dropdownAnswers.map(function (answeritem) {
                    //all answers for this question
                    if (prevItem == answeritem.value) {
                      currGroups.map(function (currGroup) {
                        //groups of the clicked item
                        var matched = false;
                        answeritem.groups.map(function (answerGroup) {
                          if (answerGroup == currGroup) {
                            matched = true;
                          }
                        });
                        if (matched == true) {
                          newAnswers.push(prevItem);
                        }
                      });
                    }
                  });
                });
              }
              var preceedingQuestions = [].concat(parents, [question.questionID]);
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp(preceedingQuestions, {
                  $set: newAnswers
                }))
              }, function () {
                _this0.updateParentData();
                console.log('CustomCheckboxGroup onChange complete');
              });
            } else {
              var _preceedingQuestions = [].concat(parents, [question.questionID]);
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp(_preceedingQuestions, {
                  $set: newArr
                }))
              }, function () {
                _this0.updateParentData();
                console.log('CustomCheckboxGroup onChange complete 2');
              });
            }
          },
          previousValue: (0, _lodash.isArray)(_previousValue) ? _previousValue : [],
          answers: [].concat(dropdownAnswers),
          resources: resources,
          language: language,
          required: question.isRequired
        })));
      } else if (question.controlType === 'CustomDiamServiceCheckbox') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomDiamServiceCheckbox["default"], {
          className: classes.radioGroup,
          key: elementKey,
          answers: [].concat(dropdownAnswers),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            if (!value.target) {
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                  $set: value
                }))
              }, function () {
                _this0.updateParentData();
                console.log('CustomDiamServiceCheckbox onChange complete');
              });
            }
          },
          showError: this.showError
        })));
      } else if (question.controlType === 'CustomCheckboxText') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, question.hint !== '' && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomCheckboxText["default"], {
          className: classes.radioGroup,
          key: elementKey,
          answers: [].concat(dropdownAnswers),
          validationRule: question.validationRule,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            if (!value.target) {
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                  $set: value
                }))
              }, function () {
                _this0.updateParentData();
              });
            }
          }
        })));
      } else if (question.controlType === 'Date') {
        var dateValue = this.getValue(true, [].concat(parents, [question.questionID]));
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement("input", {
          className: classes.datePicker,
          type: "date",
          onChange: function onChange(event) {
            if (_this0.props.surveyTemplate === 'One Page') {
              _this0.updateParentData((0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: [event.target.value]
              })));
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                  $set: [event.target.value]
                }))
              }, function () {
                return console.log('MuiPickersUtilsProvider onChange complete');
              });
            } else {
              _this0.setState({
                data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                  $set: [event.target.value]
                }))
              }, function () {
                return console.log('MuiPickersUtilsProvider onChange complete');
              });
            }
          },
          value: dateValue ? dateValue : ''
        })));
      } else if (question.controlType === 'Description') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlDesc,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_CustomDescription["default"], {
          className: classes.titleOne,
          description: question.questionDescription
        }), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')));
      } else if (question.controlType === 'CustomLabel') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlNoBottom,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomDescription["default"], {
          className: classes.textField,
          description: this.getValue(true, [].concat(parents, [question.questionID]))
        })));
      } else if (question.controlType === 'TechnologyInstallation') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTechnologyInstallation["default"], {
          distinctProducts: this.state.distinctProducts,
          vendorsList: this.state.translatedVendorsList,
          productsList: this.state.translatedProductsList,
          countryID: this.state.countryID,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyInstallation onChange complete');
            });
          },
          answers: [].concat(dropdownAnswers),
          contractDurations: this.state.contractDurations,
          contractDates: this.state.contractDates,
          standardYesNoOptions: this.state.standardYesNoOptions,
          planUpgradeTimeframeOptions: this.state.planUpgradeTimeframeOptions,
          levelOfIntegration: this.state.levelOfIntegration,
          resources: this.props.resources,
          language: this.props.language
        })));
      } else if (question.controlType === 'DigitalRadarTechnologyInstallation' || question.controlType === 'DigitalRadarTechnologyInstallation_NoIntegrationLevel') {
        var showIntegrationLevel = question.controlType !== 'DigitalRadarTechnologyInstallation_NoIntegrationLevel';
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomDigitalRadarTechnologyInstallation["default"], {
          vendorsList: this.state.translatedVendorsList,
          countryID: this.state.countryID,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
            });
          },
          answers: [].concat(dropdownAnswers),
          levelOfIntegration: this.state.levelOfIntegration,
          resources: this.props.resources,
          language: this.props.language,
          showIntegrationLevel: showIntegrationLevel
        })));
      } else if (question.controlType === 'DiamTechnologyInstallation') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTechnologyInstallation["default"], {
          distinctProducts: this.state.distinctProducts,
          vendorsList: this.state.translatedVendorsList,
          productsList: this.state.translatedProductsList,
          countryID: this.state.countryID,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyInstallation onChange complete');
            });
          },
          answers: [].concat(dropdownAnswers),
          contractDurations: this.state.contractDurations,
          contractDates: this.state.contractDates,
          standardYesNoOptions: this.state.standardYesNoOptions,
          planUpgradeTimeframeOptions: this.state.planUpgradeTimeframeOptions,
          levelOfIntegration: this.state.diamLevelOfIntegration,
          resources: this.props.resources,
          language: this.props.language
        })));
      } else if (question.controlType === 'DiamTechnologyInstallation_NoIntegrationLevel') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTechnologyInstallation["default"], {
          distinctProducts: this.state.distinctProducts,
          vendorsList: this.state.translatedVendorsList,
          productsList: this.state.translatedProductsList,
          countryID: this.state.countryID,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyInstallation onChange complete');
            });
          },
          answers: [].concat(dropdownAnswers),
          contractDurations: this.state.contractDurations,
          contractDates: this.state.contractDates,
          standardYesNoOptions: this.state.standardYesNoOptions,
          planUpgradeTimeframeOptions: this.state.planUpgradeTimeframeOptions,
          levelOfIntegration: null,
          resources: this.props.resources,
          language: this.props.language
        })));
      } else if (question.controlType === 'TechnologyPlans') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTechnologyPlans["default"], {
          entity: this.props.entity,
          questions: this.props.allQuestions,
          key: "".concat(this.props.tabId - elementKey),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyPlans onChange complete');
            });
          },
          technologiesList: this.props.technologiesList,
          typesOfInvestment: this.state.typesOfInvestment,
          yearOfContract: this.state.yearOfContract,
          resources: this.props.resources,
          language: this.props.language
          //levelOfIntegration={find(answers, { answerID: 310 }) ? find(answers, { answerID: 310 }).answers : []}
        })));
      } else if (question.controlType === 'VendorProductSelect') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomVendorProductSelect["default"], {
          vendorsList: this.props.vendorsList,
          productsList: this.props.productsList,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          allowMultiple: false,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyPlans onChange complete');
            });
          }
        })));
      } else if (question.controlType === 'MultiVendorProductSelect') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomVendorProductSelect["default"], {
          vendorsList: this.props.vendorsList,
          productsList: this.props.productsList,
          entity: this.props.entity,
          technologyId: this.props.techQuestionsForm ? this.props.tabId : Number(question.technologyID),
          key: "".concat(this.props.tabId - elementKey),
          allowMultiple: true,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomTechnologyPlans onChange complete');
            });
          }
        })));
      } else if (question.controlType === 'CustomCertifiedOrg') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomCertifiedOrg["default"], {
          key: elementKey,
          certifiedOrgs: [].concat(this.state.certifiedOrgs),
          certifiedOrgTechID: this.state.certifiedOrgTechID,
          answers: [].concat(dropdownAnswers),
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          resources: this.props.resources,
          language: this.props.language,
          yesAnswerValue: '298',
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
            });
          }
        })));
      } else if (question.controlType === 'DiamQuestion') {
        if (!this.state.serviceList || this.state.serviceList.length === 0) return;
        var data = this.state.data;
        var questionData = this.getQuestionData(data, question.questionID);
        var _blankOption2 = [{
          label: '',
          value: ''
        }];
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomDiamQuestion["default"], {
          parentQuestionNumbers: parentQuestionNumbers != null ? [].concat(parentQuestionNumbers, [questionNumber]) : [questionNumber],
          questionData: questionData,
          serviceList: this.state.serviceList,
          key: elementKey,
          questionID: question.questionID,
          branchingQuestions: question.branchingQuestions,
          questions: this.props.questions,
          answers: this.props.answers,
          options: _blankOption2.concat([].concat(dropdownAnswers)),
          useDropdown: question.answerID > 0,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          language: this.props.language,
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
              console.log('CustomDiamQuestion onChange complete');
            });
          },
          onBranchingQuestionChange: function onBranchingQuestionChange(questionIDs, value) {
            //let newData = cloneDeep(this.state.data);
            //this.setData(newData, questionIDs, 0, value);
            //console.log('updated data', newData);
            //if (data) this.setState({ data: newData });
            //force state data update
            _this0.state.data = (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, questionIDs), {
              $set: value
            }));
            //this.setState({
            //  data: update(this.state.data, this.makeProp([...parents, ...questionIDs], { $set: value }))
            //});
          }
        })));
      } else if (question.controlType === 'DiamRespondentInfo') {
        if (!this.state.serviceList || this.state.serviceList.length === 0) return;
        var _data = this.state.data;
        var _questionData = this.getQuestionData(_data, question.questionID);
        var _blankOption3 = [{
          label: '',
          value: ''
        }];
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomRespondentInformation["default"], {
          parentQuestionNumbers: parentQuestionNumbers != null ? [].concat(parentQuestionNumbers, [questionNumber]) : [questionNumber],
          serviceList: this.state.serviceList,
          key: elementKey,
          questionID: question.questionID,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          language: this.props.language,
          resources: this.props.resources,
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
            });
          }
        })));
      } else if (question.controlType === 'DiamFreeTextQuestion') {
        if (!this.state.serviceList || this.state.serviceList.length === 0) return;
        var _data2 = this.state.data;
        var _questionData2 = this.getQuestionData(_data2, question.questionID);
        var _blankOption4 = [{
          label: '',
          value: ''
        }];
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomDiamFreeTextQuestion["default"], {
          parentQuestionNumbers: parentQuestionNumbers != null ? [].concat(parentQuestionNumbers, [questionNumber]) : [questionNumber],
          serviceList: this.state.serviceList,
          key: elementKey,
          questionID: question.questionID,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          language: this.props.language,
          validationRule: question.validationRule,
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
            });
          }
        })));
      } else if (!(0, _lodash.isEmpty)(question.validationRule) && question.validationRule.validatorFunctionName === 'isPhoneNumber') {
        var _previousValue2 = this.getValue(false, [].concat(parents, [question.questionID]));
        var value = this.getValue(true, [].concat(parents, [question.questionID]));

        //get the country name here!
        var _regions = this.props.regions;
        var countryName = 'us';
        if (this.state.countryID > 0) {
          _regions.map(function (r) {
            if (r.countryID == _this0.state.countryID) {
              countryName = r.country;
            }
          });
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlNoBottom,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomPhoneNumberInput["default"], {
          country: countryName,
          value: value ? value : '',
          previousValue: _previousValue2,
          name: "".concat(question.questionID),
          onChange: this.updatePhoneNumber([].concat(parents, [question.questionID]))
          /* Currently don't validate this. Need to change this once we start validating inputs. */,
          shouldValidate: false
        })));
      } else if (question.controlType === 'Address') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomAddress["default"], {
          classes: classes,
          key: elementKey,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          language: this.props.language,
          resources: this.props.resources,
          onCountryChange: function onCountryChange(countryID) {
            _this0.setState({
              countryID: countryID
            });
          },
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: value
              }))
            }, function () {
              _this0.updateParentData();
            });
          }
        })));
      } else if (question.controlType === 'TextBox' && question.validationRule.validatorFunctionName === 'isPercent') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomNumber["default"], {
          className: classes.textField,
          isAllowed: function isAllowed(val) {
            var value = val.value;
            return value >= 0 && value <= 100;
          },
          key: elementKey,
          suffix: '%',
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: [value]
              }))
            }, function () {
              _this0.updateParentData();
            });
          },
          decimalSeparator: this.props.language === null || this.props.language === 'English' || this.props.language === 'British English' ? '.' : ',',
          thousandSeparator: this.props.language === null || this.props.language === 'English' || this.props.language === 'British English' ? ',' : '.'
        })));
      } else if (question.controlType === 'TextBox' && question.validationRule.validatorFunctionName === 'isCurrencyDollar') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomNumber["default"], {
          className: classes.textField,
          key: elementKey,
          prefix: '$',
          thousandSeparator: true,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: [value]
              }))
            }, function () {
              _this0.updateParentData();
            });
          }
        })));
      } else if (question.controlType === 'TextBox' && question.validationRule.validatorFunctionName === 'isFloat') {
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControl,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomNumber["default"], {
          className: classes.textField,
          key: elementKey,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          onChange: function onChange(value) {
            _this0.setState({
              data: (0, _reactAddonsUpdate["default"])(_this0.state.data, _this0.makeProp([].concat(parents, [question.questionID]), {
                $set: [value]
              }))
            }, function () {
              _this0.updateParentData();
            });
          },
          format: question.validationRule.maxDigits ? '#'.repeat(question.validationRule.maxDigits) : undefined,
          decimalSeparator: this.props.language === null || this.props.language === 'English' || this.props.language === 'British English' ? '.' : ',',
          thousandSeparator: this.props.language === null || this.props.language === 'English' || this.props.language === 'British English' ? ',' : '.'
        })));
      } else if (question.controlType === 'TextBox' && question.isRequired) {
        //Temporarily dump out all the remaining form controls as textboxes
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlNoBottom,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTextField["default"], {
          className: classes.textField,
          key: question.questionID,
          margin: "dense",
          name: question.questionID,
          onChange: this.updateFields([].concat(parents, [question.questionID])),
          previousValue: this.getValue(false, [].concat(parents, [question.questionID])),
          validationRule: question.validationRule,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          required: question.isRequired,
          questionDescription: "".concat(questionNumberLabel, " ").concat(question.questionDescription),
          fullWidth: true
        })));
      } else if (question.controlType === 'TextArea') {
        var textAreaProps = {};
        if (question.isRequired) {
          textAreaProps['required'] = question.isRequired;
        }
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlNoBottom,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTextArea["default"], {
          required: question.isRequired,
          fullWidth: true,
          className: classes.textField,
          style: {
            overflowY: 'scroll'
          },
          key: question.questionID,
          margin: "dense",
          name: question.questionID,
          onChange: this.updateFields([].concat(parents, [question.questionID])),
          previousValue: this.getValue(false, [].concat(parents, [question.questionID])),
          validationRule: question.validationRule,
          value: this.getValue(true, [].concat(parents, [question.questionID])),
          questionDescription: "".concat(questionNumberLabel, " ").concat(question.questionDescription)
        })));
      } else {
        //Temporarily dump out all the remaining form controls as textboxes
        return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
          className: classes.formControlNoBottom,
          key: question.questionID
        }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
          className: classes.titleOne
        }, /*#__PURE__*/_react["default"].createElement("strong", null, questionNumberLabel), " ", question.questionDescription, !(0, _lodash.isEmpty)(question.hint) && /*#__PURE__*/_react["default"].createElement(_CustomHint["default"], {
          hint: question.hint
        })), /*#__PURE__*/_react["default"].createElement(_material.FormLabel, null, (0, _htmlReactParser["default"])(question.additionalDescription ? question.additionalDescription : '')), /*#__PURE__*/_react["default"].createElement("div", {
          className: classes.padTop
        }, /*#__PURE__*/_react["default"].createElement(_CustomTextFieldDefaultValue["default"], {
          className: classes.textField,
          key: question.questionID,
          margin: "dense",
          name: question.questionID,
          onBlur: this.updateFields([].concat(parents, [question.questionID])),
          previousValue: this.getValue(false, [].concat(parents, [question.questionID])),
          validationRule: question.validationRule,
          defaultValue: this.getValue(true, [].concat(parents, [question.questionID])),
          required: question.isRequired,
          fullWidth: true
        })));
      }
    }
  }, {
    key: "createQuestionComment",
    value: function createQuestionComment(question, resources, language, classes, userResponse) {
      return /*#__PURE__*/_react["default"].createElement(_material.FormControl, {
        className: classes.formControlNoBottom,
        key: question.questionID + '-comment'
      }, /*#__PURE__*/_react["default"].createElement(_material.FormLabel, {
        className: classes.titleOne
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Comments')), /*#__PURE__*/_react["default"].createElement("div", {
        className: classes.padTop
      }, /*#__PURE__*/_react["default"].createElement(_CustomTextArea["default"], {
        fullWidth: true,
        className: classes.textField,
        style: {
          overflowY: 'scroll'
        },
        key: question.questionID + '-comment',
        margin: "dense",
        name: question.questionID + '-comment',
        onBlur: this.updateQuestionComment([].concat(userResponse, [question.questionID])),
        defaultValue: this.getQuestionCommentValue(this.state.data, [].concat(userResponse, [question.questionID]))
      })));
    }
  }, {
    key: "getBranchingQuestions",
    value: function getBranchingQuestions(parentQuestionNumbers, question, questionIDs) {
      var _this1 = this;
      var branchingQuestions = [];
      var answers = this.getValue(true, questionIDs);
      if (!answers) return branchingQuestions;
      /* If there are no branching questions, return an empty array */
      if ((0, _lodash.isEmpty)(question.branchingQuestions)) return branchingQuestions;

      /* Search the answers for the answer key for this question. If it isn't found, return. */
      var answer = (0, _lodash.find)(this.props.answers, {
        answerID: question.answerID
      });
      if (!answer) return branchingQuestions;

      /* If the answer is a string, convert it to an array with that single element so it can be processed */
      var isString = typeof answers === 'string';
      var answersList = answers;
      if (isString) {
        answersList = [answers];
      }

      /* If the question is a tech installation the branching question is just the first string in each row */
      if (question.controlType === 'TechnologyInstallation' || question.controlType === 'DiamTechnologyInstallation' || question.controlType === 'DiamTechnologyInstallation_NoIntegrationLevel' || question.controlType === 'DigitalRadarTechnologyInstallation' || question.controlType === 'DigitalRadarTechnologyInstallation_NoIntegrationLevel') {
        answersList = answersList.map(function (a) {
          var arr = JSON.parse(a);
          var matchingAnswer = (0, _lodash.find)(answer.answers, {
            value: arr[0]
          });
          return matchingAnswer;
        });
        answersList = (0, _lodash.uniq)(answersList);
      }
      if (question.controlType === 'CustomDiamServiceCheckbox') {
        answersList = answersList.map(function (a) {
          var svc = JSON.parse(a);
          return svc.serviceID;
        });
        answersList = (0, _lodash.uniq)(answersList);
      }
      if (question.controlType === 'CustomCertifiedOrg') {
        answersList = answersList.map(function (a) {
          var arr = JSON.parse(a);
          var matchingAnswer = (0, _lodash.find)(answer.answers, {
            value: arr[0]
          });
          return matchingAnswer;
        });
        answersList = (0, _lodash.uniq)(answersList);
      }
      if (question.controlType === 'SingleDropDownList') {
        answersList = [answers];
      }
      var subNumber = 0;
      /* For each answer found, find all branching questions for that answer. */
      answersList.forEach(function (answerObject) {
        /* If the answerObject is undefined or an empty string, skip this answer */
        if (!answerObject) return;
        var answerID;
        /* If this answerObject is a string, it is already the answerID so set it */
        if (isString) {
          answerID = answerObject;
        } else {
          /* Find the answer from the list of answers */
          var matchingAnswer = (0, _lodash.find)(answer.answers, {
            value: answerObject.value
          });

          /* The data model is slightly different for checkbox lists - ARCH CHANGE IN THE FUTURE */
          if (!matchingAnswer) {
            matchingAnswer = (0, _lodash.find)(answer.answers, {
              value: answerObject
            });
          }
          if (matchingAnswer) {
            /* If the answer was found, set it to the answerID value */
            answerID = matchingAnswer.value;
          }
        }
        /* If the question has branching questions for this answer, return a list of them. */
        if (answerID && question.branchingQuestions[answerID]) {
          var _branchingQuestions;
          /* Get an array of questionIDs to display for this answer */
          var newQuestionIds = question.branchingQuestions[answerID];
          /* Get the full question objects for all branching questions */

          (_branchingQuestions = branchingQuestions).push.apply(_branchingQuestions, newQuestionIds.reduce(function (all, qId) {
            var branchingQuestion = (0, _lodash.find)(_this1.props.questions, {
              questionID: Number(qId)
            });
            if (branchingQuestion) {
              var showChild = true;
              if (branchingQuestion.parentQuestions && Object.keys(branchingQuestion.parentQuestions).length > 0) {
                var questionData = _this1.props.entity.data.questions;
                var addressQuestion = _this1.props.questions.find(function (q) {
                  return q.mappingGroupAttribute === '-5';
                });
                showChild = Object.keys(branchingQuestion.parentQuestions).every(function (k) {
                  if (Number(k) === 805 && addressQuestion) {
                    //if parent question is Country then look for Address question
                    var result = (0, _surveyUtils.checkParentQuestionData)(addressQuestion.questionID.toString(), branchingQuestion.parentQuestions[k], questionData, addressQuestion);
                    return result;
                  } else {
                    var parentQuestionInfo = _this1.props.questions.find(function (q) {
                      return q.questionID === Number(k);
                    });
                    var _result = (0, _surveyUtils.checkParentQuestionData)(k, branchingQuestion.parentQuestions[k], questionData, parentQuestionInfo);
                    return _result;
                  }
                });
              }
              if (showChild) {
                /* If the branching question was found, create the form element for it. */
                all.push(_this1.createFormElements(parentQuestionNumbers, (0, _surveyUtils.numberToLetter)(subNumber), branchingQuestion, questionIDs));
                /* See if this branching question has any branching questions. If so, add them to the form. */
                var nestedBranchingQuestions = _this1.getBranchingQuestions([].concat(parentQuestionNumbers, [(0, _surveyUtils.numberToLetter)(subNumber)]), branchingQuestion, [].concat(questionIDs, [branchingQuestion.questionID]));
                if (nestedBranchingQuestions) {
                  all.push.apply(all, nestedBranchingQuestions);
                }
                subNumber = subNumber + 1;
              }
            }
            return all;
          }, []));
        }
      });

      //Multi-select and Tech Installation can have multiple answers selected that branch to the same set of question
      //This can cause duplicate branching questions to appear for a single question so we need to filter out the duplicates
      branchingQuestions = (0, _lodash.uniqBy)(branchingQuestions, 'key');
      return branchingQuestions;
    }
  }, {
    key: "render",
    value: function render() {
      var _this10 = this;
      var _this$state = this.state,
        questions = _this$state.questions,
        promptError = _this$state.promptError,
        errorMessage = _this$state.errorMessage;
      var _this$props4 = this.props,
        classes = _this$props4.classes,
        resources = _this$props4.resources,
        language = _this$props4.language;
      var questionNumber = this.props.questionNumberStart;
      this.setLocale(this.props.language);
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, questions.map(function (question, idx) {
        var parentElements = [];
        if ('technologies' in question) parentElements = [_this10.props.tabId];

        /* Add the question */
        var element = _this10.createFormElements(null, questionNumber, question, parentElements);
        var branchingElements = [];
        //Skip calling getValue on a Descrition and just assume we have no branching questions.
        if (question.controlType !== 'Description' && question.controlType !== 'CustomLabel' && question.controlType !== 'DiamQuestion' && question.controlType !== 'DiamFreeTextQuestion' && question.controlType !== 'DiamRespondentInfo') {
          /* Add any branching questions */
          branchingElements = _this10.getBranchingQuestions([].concat(questionNumber), question, [].concat(parentElements, [question.questionID]));
        }
        if (question.controlType !== 'Description' && question.controlType !== 'CustomLabel') {
          questionNumber = questionNumber + 1;
        }
        if (question.enableComments) {
          var questionComment = _this10.createQuestionComment(question, resources, language, classes, [].concat(parentElements));
          return [element].concat(branchingElements, questionComment);
        }
        return [element].concat(branchingElements);
      }));
    }
  }], [{
    key: "getAnswers",
    value: function getAnswers(questionData, questionID) {
      var answer = [];
      Object.keys(questionData).forEach(function (k) {
        if (k == questionID) {
          answer = questionData[questionID].answer;
        }
        if (questionData[k].questions.length > 0) {
          answer = CustomForm.getAnswers(questionData[k].questions, questionID);
        }
      });
      return answer;
    }
  }, {
    key: "translateAnswer",
    value: function translateAnswer(answerList, language) {
      if (answerList.length > 0) {
        answerList.forEach(function (a) {
          if (a.translations && a.translations[language]) {
            a.label = a.translations[language];
          }
        });
      }
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      console.log('CustomForm.js getDerivedStateFromProps');
      if (props.productsList) {
        state.distinctProducts = (0, _lodash.uniqBy)(props.productsList, 'value');
        state.translatedProductsList = props.productsList.map(function (s) {
          return s.label.toLowerCase() === 'other' ? _objectSpread(_objectSpread({}, s), {}, {
            label: (0, _getResource.getResource)(props.resources, props.language, 'Label', 'other').toString().toUpperCase()
          }) : s.label.toLowerCase() === 'self-developed' ? _objectSpread(_objectSpread({}, s), {}, {
            label: (0, _getResource.getResource)(props.resources, props.language, 'Label', 'self-developed').toString().toUpperCase()
          }) : s;
        });
      }
      if (props.vendorsList) {
        state.translatedVendorsList = props.vendorsList.map(function (p) {
          return p.label.toLowerCase() === 'other' ? _objectSpread(_objectSpread({}, p), {}, {
            label: (0, _getResource.getResource)(props.resources, props.language, 'Label', 'other').toString().toUpperCase()
          }) : p.label.toLowerCase() === 'self-developed' ? _objectSpread(_objectSpread({}, p), {}, {
            label: (0, _getResource.getResource)(props.resources, props.language, 'Label', 'self-developed').toString().toUpperCase()
          }) : p;
        });
      }
      if (props.scoringType && props.vendorsList) {
        var techID = (0, _surveyUtils.scoringTypeToTechID)(props.scoringType);
        if (techID) {
          var filteredVendorsList = props.vendorsList.reduce(function (all, v) {
            var matchesTech = v.technologies.length === 0 || v.technologies.includes(techID);
            if (matchesTech) all.push(v);
            return all;
          }, []);
          state.certifiedOrgs = filteredVendorsList;
          state.certifiedOrgTechID = techID;
        } else state.certifiedOrgs = [];
      }

      //Check if the pageId has changed and save the entity data if there are changes
      console.log('getDerivedStateFromProps on CustomForm.js', state.tabId, props.tabId);
      if (state.tabId !== props.tabId) {
        var data = _objectSpread({}, props.entity.data);
        if (state.techQuestionsForm) {
          data = _objectSpread(_objectSpread({}, data), {}, {
            technologyQuestions: _objectSpread({}, state.data)
          });
        } else {
          data = _objectSpread(_objectSpread({}, data), {}, {
            questions: _objectSpread({}, state.data)
          });
        }
        console.log('calling props.onSubimt on CustomForm.js', !(0, _lodash.isEqual)(data, props.entity.data));
        if (!(0, _lodash.isEqual)(data, props.entity.data)) {
          console.log('calling props.onSubimt on CustomForm.js');
          props.onSubmit(data);
        }
        state.tabId = props.tabId;
      }
      if (props.questions && props.entity.data) {
        var questions = props.questions.filter(function (i) {
          var showChild = true;
          if (i.parentQuestions && Object.keys(i.parentQuestions).length > 0) {
            var questionData = props.entity.data.questions;
            var addressQuestion = props.questions.find(function (q) {
              return q.mappingGroupAttribute === '-5';
            });
            showChild = Object.keys(i.parentQuestions).every(function (k) {
              if (Number(k) === 805 && addressQuestion) {
                //if parent question is Country then look for Address question
                var result = (0, _surveyUtils.checkParentQuestionData)(addressQuestion.questionID.toString(), i.parentQuestions[k], questionData, addressQuestion);
                return result;
              } else {
                var parentQuestionInfo = props.questions.find(function (q) {
                  return q.questionID === Number(k);
                });
                var _result2 = (0, _surveyUtils.checkParentQuestionData)(k, i.parentQuestions[k], questionData, parentQuestionInfo);
                return _result2;
              }
            });
          }
          // If these are technology questions, display all of them that apply to this technology.
          if (props.techQuestionsForm && props.entity.data.technologyQuestions) {
            var questionsList = props.entity.data.technologyQuestions[props.tabId];
            if (questionsList && i.questionID in questionsList) {
              var showQuestion = i.technologies.includes(props.tabId) || i.technologies.length === 0;
              return showQuestion && showChild;
            }
          } else if (props.entity.data.questions) {
            if (i.questionID in props.entity.data.questions) return i.tabID === props.tabId && showChild;
          }
          return false;
        });
        //Which imaging services do you want to assess? 1935
        var serviceQuestion = props.questions.find(function (q) {
          return q.mappingTo === 'HA Database' && q.mappingGroupAttribute === '-3';
        });
        if (serviceQuestion) {
          var services = CustomForm.getAnswers(props.entity.data.questions, serviceQuestion.questionID);

          //Imaging Services 325
          var imagingServices = props.answers.find(function (a) {
            return a.answerID === 325;
          });
          if (imagingServices) {
            var serviceList = services.map(function (s) {
              var serviceAnswer = JSON.parse(s);
              var svc = (0, _lodash.cloneDeep)(imagingServices.answers.find(function (a) {
                return a.value == serviceAnswer.serviceID;
              }));
              var isOtherService = _surveyUtils.otherServices.indexOf(svc.value) > -1;
              if (isOtherService && serviceAnswer.otherLabel) svc.label = serviceAnswer.otherLabel;
              return svc;
            });
            if (props.language) {
              serviceList.forEach(function (a) {
                if (a.translations && a.translations[props.language]) {
                  a.label = a.translations[props.language];
                }
              });
            }
            state['serviceList'] = (0, _lodash.sortBy)(serviceList, ['label']);
          }
        }
        var contractDurations = (0, _lodash.find)(props.answers, {
          answerID: 9
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 9
        }).answers) : [];
        var contractDates = (0, _lodash.find)(props.answers, {
          answerID: 119
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 119
        }).answers) : [];
        var standardYesNoOptions = (0, _lodash.find)(props.answers, {
          answerID: 13
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 13
        }).answers) : [];
        var planUpgradeTimeframeOptions = (0, _lodash.find)(props.answers, {
          answerID: 16
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 16
        }).answers) : [];
        var levelOfIntegration = (0, _lodash.find)(props.answers, {
          answerID: 310
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 310
        }).answers) : [];
        var diamLevelOfIntegration = (0, _lodash.find)(props.answers, {
          answerID: 344
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 344
        }).answers) : [];
        var typesOfInvestment = (0, _lodash.find)(props.answers, {
          answerID: 308
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 308
        }).answers) : [];
        var yearOfContract = (0, _lodash.find)(props.answers, {
          answerID: 314
        }) ? (0, _lodash.cloneDeep)((0, _lodash.find)(props.answers, {
          answerID: 314
        }).answers) : [];
        if (props.language) {
          CustomForm.translateAnswer(contractDurations, props.language);
          CustomForm.translateAnswer(contractDates, props.language);
          CustomForm.translateAnswer(standardYesNoOptions, props.language);
          CustomForm.translateAnswer(planUpgradeTimeframeOptions, props.language);
          CustomForm.translateAnswer(levelOfIntegration, props.language);
          CustomForm.translateAnswer(diamLevelOfIntegration, props.language);
          CustomForm.translateAnswer(typesOfInvestment, props.language);
          CustomForm.translateAnswer(yearOfContract, props.language);
        }
        var countryID = null;
        if (props.countryQuestion) {
          if (props.entity.data.questions[props.countryQuestion.questionID].answer.length > 0) {
            try {
              var address = JSON.parse(props.entity.data.questions[props.countryQuestion.questionID].answer[0]);
              countryID = address.countryID;
            } catch (_unused) {
              countryID = props.entity.data.questions[props.countryQuestion.questionID].answer[0];
            }
          }
        }
        state['contractDurations'] = contractDurations;
        state['contractDates'] = contractDates;
        state['standardYesNoOptions'] = standardYesNoOptions;
        state['planUpgradeTimeframeOptions'] = planUpgradeTimeframeOptions;
        state['levelOfIntegration'] = levelOfIntegration;
        state['diamLevelOfIntegration'] = diamLevelOfIntegration;
        state['typesOfInvestment'] = typesOfInvestment;
        state['yearOfContract'] = yearOfContract;
        state['questions'] = (0, _lodash.sortBy)(questions, ['sortOrder']);
        state['countryID'] = countryID;
      }
      if (!(0, _lodash.isEqual)(state.prevEntity.data, props.entity.data)) {
        var _data3 = {};
        var prevData = {};
        if (props.entity.data && props.techQuestionsForm && props.entity.data.technologyQuestions) {
          _data3 = _objectSpread({}, props.entity.data.technologyQuestions);
        } else if (props.entity.data && props.entity.data.questions) {
          _data3 = _objectSpread({}, props.entity.data.questions);
        }
        if (props.entity.prevData && props.techQuestionsForm && !props.isBlankAssessment) {
          prevData = props.entity.prevData.technologyQuestions ? props.entity.prevData.technologyQuestions : {};
        } else if (props.entity.prevData && !props.isBlankAssessment) {
          prevData = props.entity.prevData.questions ? props.entity.prevData.questions : {};
        }
        state.data = _data3;
        state.prevData = prevData;
        /* Only set the techQuestionsForm state if the data is set */
        if (!(0, _lodash.isEmpty)(_data3)) {
          state.techQuestionsForm = props.techQuestionsForm;
          state.prevEntity = props.entity;
        }
      }
      return state;
    }
  }]);
}(_react.Component);
CustomForm.propTypes = {
  answers: _propTypes["default"].array.isRequired,
  countriesList: _propTypes["default"].array,
  entity: _propTypes["default"].object.isRequired,
  onSubmit: _propTypes["default"].func.isRequired,
  onSaveChanges: _propTypes["default"].func.isRequired,
  productsList: _propTypes["default"].array,
  questions: _propTypes["default"].array.isRequired,
  regionsList: _propTypes["default"].array,
  surveyTemplate: _propTypes["default"].string,
  tabId: _propTypes["default"].number.isRequired,
  techQuestionsForm: _propTypes["default"].bool.isRequired,
  technologiesList: _propTypes["default"].array.isRequired,
  vendorsList: _propTypes["default"].array,
  regions: _propTypes["default"].array,
  isBlankAssessment: _propTypes["default"].bool
};
var enhance = (0, _redux.compose)((0, _styles.withStyles)(styles), _reactRouterDom.withRouter, (0, _reactRedux.connect)(null, null, null, {
  forwardRef: true
}));
var forwardedForm = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(CustomForm, (0, _extends2["default"])({
    ref: ref
  }, props));
});
var _default = exports["default"] = enhance(forwardedForm);